// extracted by mini-css-extract-plugin
export default {"secondaryButton":"SecondaryButton_secondaryButton__mA0TF","disabled":"SecondaryButton_disabled__BJry4"};